import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Prestations, Parfums, Avantages, Etapes, Temoignages } from "@/components/site/Sections";
import { ToppingsCoulis } from "@/components/site/ToppingsCoulis";
import { Galerie } from "@/components/site/Galerie";
import { FaqSection } from "@/components/site/FaqSection";
import { DevisForm } from "@/components/site/DevisForm";
import { ContactSection } from "@/components/site/ContactSection";
import { Footer } from "@/components/site/Footer";
import { FloatingActions } from "@/components/site/FloatingActions";

export default function Home() {
  useEffect(() => {
    document.title = "Moum's — Glace à l'italienne à Stains (93) | Prestataire événementiel";
  }, []);

  return (
    <main className="bg-cream">
      <Header />
      <Hero />
      <Prestations />
      <Parfums />
      <ToppingsCoulis />
      <Etapes />
      <Avantages />
      <Galerie />
      <Temoignages />
      <DevisForm />
      <FaqSection />
      <ContactSection />
      <Footer />
      <FloatingActions />
    </main>
  );
}
